/** @format */

export const PRICELIST_UPLOAD_STATUS = {
    STATUS_IMPORT_AWAIT: 1,
    STATUS_IMPORT_PROCESS: 2,
    STATUS_IMPORT_FINISH: 3,
    STATUS_ERROR: -1,
};

export const getPricelistUploadFileStatus = (status: number): string => {
    switch (status) {
        case PRICELIST_UPLOAD_STATUS.STATUS_IMPORT_AWAIT:
            return 'pricelists:import_status.import_awaiting';
        case PRICELIST_UPLOAD_STATUS.STATUS_IMPORT_PROCESS:
            return 'pricelists:import_status.import_in_progress';
        case PRICELIST_UPLOAD_STATUS.STATUS_IMPORT_FINISH:
            return 'pricelists:import_status.import_success';
        case PRICELIST_UPLOAD_STATUS.STATUS_ERROR:
            return 'pricelists:import_status.import_error';
        default:
            return 'pricelists:import_status.unknown';
    }
};
